module.exports = __webpack_public_path__ + "img/team-suggested.3de370ca.svg";